var _rect, _path, _path2, _g, _path3, _path4, _path5, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBomblarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    viewBox: "0 0 217 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 216,
    height: 44,
    rx: 7.5,
    fill: "#27191B",
    stroke: "url(#paint0_linear_621_421)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.314 2.95136C112.674 2.57504 111.856 2.79837 111.486 3.45017L109.114 7.63296C108.047 7.44494 106.948 7.34688 105.827 7.34688C95.4289 7.34688 87 15.7758 87 26.1734C87 36.571 95.4289 44.9999 105.827 44.9999C116.224 44.9999 124.653 36.571 124.653 26.1734C124.653 20.7725 122.379 15.9028 118.736 12.4696L120.759 8.90127C121.129 8.24947 120.909 7.41601 120.269 7.03969L113.314 2.95136Z",
    fill: "#34384F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.09 0.00511045C125.275 -0.109197 128.101 1.7157 129.709 3.30835C130.24 3.83386 130.24 4.68589 129.709 5.2114C129.179 5.73691 128.318 5.73691 127.787 5.2114C126.451 3.88845 124.316 2.61833 122.189 2.69466C120.244 2.76443 117.781 3.99496 115.73 8.81904C115.439 9.50399 114.642 9.82546 113.95 9.53706C113.258 9.24866 112.933 8.4596 113.225 7.77466C115.522 2.37173 118.722 0.125973 122.09 0.00511045Z",
    fill: "#FF9299"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_621_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.486 3.45022C111.856 2.79841 112.674 2.57509 113.314 2.95141L120.269 7.03973C120.909 7.41605 121.129 8.24951 120.759 8.90132L117.395 14.8333L108.122 9.38219L111.486 3.45022Z",
    fill: "#34384F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.403 26.1735C124.403 36.433 116.086 44.75 105.827 44.75C95.567 44.75 87.25 36.433 87.25 26.1735C87.25 15.9139 95.567 7.59692 105.827 7.59692C116.086 7.59692 124.403 15.9139 124.403 26.1735Z",
    fill: "#34384F",
    stroke: "url(#paint1_linear_621_421)",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.735 25.8924C123.735 35.6853 115.663 43.6225 105.706 43.6225C102.154 43.628 98.6802 42.5968 95.7246 40.6596C98.1508 41.7239 100.778 42.272 103.435 42.268C113.886 42.268 122.358 33.9371 122.358 23.6592C122.363 21.0448 121.806 18.459 120.723 16.0715C122.693 18.9797 123.742 22.3977 123.735 25.8924Z",
    fill: "url(#paint2_linear_621_421)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M93.0505 21.1406C92.6161 24.2857 95.1295 27.7973 95.1295 27.7973L94.7073 30.9528L97.0528 31.749L97.8441 28.629L98.7121 28.6705L98.6078 32.2747L101.229 32.4951L101.732 29.2791C101.732 29.2791 102.472 29.2238 102.576 29.3033C102.68 29.3829 102.357 32.9023 102.357 32.9023L104.709 33L105.16 29.4252C107.024 29.2653 110.151 27.244 110.811 24.4586C111.735 20.9426 109.288 16.0952 103.084 15.1477C96.8808 14.2002 93.4865 17.9998 93.0505 21.1406ZM105.466 20.5855C106.531 21.0558 106.953 22.5627 106.409 23.9502C105.864 25.3378 104.56 26.0813 103.493 25.6101C102.426 25.139 102.005 23.6364 102.552 22.248C103.099 20.8596 104.401 20.1178 105.466 20.5881V20.5855ZM97.9069 19.23C98.8523 19.3294 99.5238 20.4109 99.4081 21.6428C99.2924 22.8748 98.4301 23.7894 97.4839 23.6892C96.5377 23.5889 95.8662 22.5082 95.9827 21.2772C96.0993 20.0461 96.9591 19.128 97.9069 19.23Z",
    fill: "url(#paint3_linear_621_421)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_621_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.5 33C110.299 33 115 28.0751 115 22C115 15.9249 110.299 11 104.5 11C98.701 11 94 15.9249 94 22C94 28.0751 98.701 33 104.5 33Z",
    fill: "url(#paint4_radial_621_421)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_621_521",
    x: 108.122,
    y: -1.23145,
    width: 12.8164,
    height: 16.0647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_621_521",
    x: 84,
    y: 1,
    width: 41,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_621_521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_421",
    x1: 108.5,
    y1: 0,
    x2: 108.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82F2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_421",
    x1: 92.5,
    y1: 13.5,
    x2: 106,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686C88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_621_421",
    x1: 109.73,
    y1: 16.0715,
    x2: 109.73,
    y2: 43.6226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#704F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704F4F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_621_421",
    x1: 102,
    y1: 15,
    x2: 102,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_621_421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.5 22) rotate(90) scale(11 10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomblarge);
export default __webpack_public_path__ + "static/media/bomblarge.fa6fc6b424fbdd481b65bd58ae01f352.svg";
export { ForwardRef as ReactComponent };